import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Linkify from 'react-linkify';
import { SelectComponent } from '../../components/quizzing/SelectComponent';
import { DateComponent } from '../../components/quizzing/DateComponent';
import { TimeComponent } from '../../components/quizzing/TimeComponent';
import { CheckBoxComponent } from '../../components/quizzing/CheckBoxComponent';
import { RadioComponent } from '../../components/quizzing/RadioComponent';
import { TextComponent } from '../../components/quizzing/TextComponent';
import { MultiTextComponent } from '../../components/quizzing/MultiTextComponent';
import { HeadingComponent } from '../../components/quizzing/HeadingComponent';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Icon from '@material-ui/core/Icon';
import { AppHelper } from '../../helpers/AppHelper';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { TableNumComponent } from '../../components/quizzing/TableNum/TableNumComponent';
import { TableNumVariant } from '../../components/quizzing/TableNum/TableNumVariant';

export class FormFieldComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      informationPopup: false,
      info: null,
    }
  }

  showInformationPopup = (ques) => {
    this.setState({
      informationPopup: true,
      info: ques.info ? ques.info : null
    });
  }

  informationPopupClose = () => {
    this.setState({ informationPopup: false });
  }

  informationPopupDialog() {
    return (
      <Dialog
        open={this.state.informationPopup}
        onClose={this.informationPopupClose}
        scroll='paper'
        classes={{
          root: css(Styles.customRoot),
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <div className={css(Styles.dialogTitleContainer)}>
            {this.state.info &&
              <p className={css(Styles.dialogTitleTxt)}>{this.state.info.title}</p>
            }
            <div className={css(Styles.dialogTitleClose)}>
              <Icon
                onClick={() => this.informationPopupClose()}
                className={css(Styles.close)}>
                close
              </Icon>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          {this.state.info &&
            <Linkify componentDecorator={(href, text, key) => AppHelper.componentDecorator(href, text, key, Styles.dialogContentData)}>
              <p className={css(Styles.dialogContentData)}>
                {this.state.info.desc}</p>
            </Linkify>
          }
        </DialogContent>
      </Dialog>
    )
  }

  render() {
    return (
      <div key={this.props.ques.id} className={css(Styles.stepperInnerContent)}>
        {this.props.ques.type === 'OPTIONS-MUL' && !this.props.multipleSelectMode &&
          <CheckBoxComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {this.props.ques.type === 'OPTIONS-MUL' && this.props.multipleSelectMode &&
          <SelectComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {(this.props.ques.type === 'YESNO' || this.props.ques.type === 'OPTIONS-SINGLE') &&
          <RadioComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            handleState={this.props.handleState}
            type={this.props.ques.type}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {(this.props.ques.type === 'TEXT-SHORT' || this.props.ques.type === 'INT' || this.props.ques.type === 'FLOAT') &&
          <TextComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {this.props.ques.type === 'TEXT-PARA' &&
          <MultiTextComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            rows={5}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {this.props.ques.type === 'DATE' &&
          <DateComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {this.props.ques.type === 'TIME' &&
          <TimeComponent
            mainTitle={this.props.ques.title}
            data={this.props.ques}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {(this.props.ques.type === 'LABEL' || this.props.ques.type === 'LABEL-BOLD') &&
          <HeadingComponent
            data={this.props.ques}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {this.props.ques.type === 'TABULAR' &&
          <TableNumComponent
            survey={true}
            data={this.props.ques}
            handleState={this.props.handleState}
          />
        }
        {this.props.ques.type === 'TABULAR_SELECT' &&
          <TableNumVariant
            survey={true}
            data={this.props.ques}
            handleState={this.props.handleState}
          />
        }
        {this.props.ques.otherAllowed === 'YES' &&
          <MultiTextComponent
            data={this.props.ques}
            rows={3}
            otherAllowedMode={true}
            handleState={this.props.handleState}
            survey={true}
            showInformationPopup={this.props.ques.info ? this.showInformationPopup : null}
          />
        }
        {this.informationPopupDialog()}
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  stepperInnerContent: {
    paddingTop: 30,
    '@media (max-width: 767px)': {
      paddingTop: 15,
    }
  },
  dialog: {
    minWidth: 800,
    maxHeight: '80vh',
    borderRadius: 31,
    padding: 30,
    '@media (max-width: 1024px)': {
      minWidth: 'unset',
      padding: 20
    }
  },
  dialogTitle: {
    padding: 0,
    paddingBottom: 16,
    '@media (max-width: 767px)': {
      paddingBottom: 10,
    }
  },
  dialogTitleContainer: {
    display: 'flex',
  },
  dialogTitleTxt: {
    color: AppTheme.primaryColor,
    margin: 0,
    fontSize: AppTheme.dialogTitleFontSize,
    fontWeight: 'normal',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.dialogTitleFontSizeBelow767,
    }
  },
  dialogTitleClose: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
  },
  close: {
    color: AppTheme.tertiaryColor,
    fontSize: 30,
    '@media (max-width: 767px)': {
      fontSize: 30,
    }
  },
  dialogContent: {
    padding: 0
  },
  dialogContentData: {
    margin: 0,
    color: AppTheme.primaryColor,
    fontSize: AppTheme.dialogContentFontSize,
    whiteSpace: 'pre-wrap',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.dialogContentFontSizeBelow767,
    }
  },
  customRoot: {
    zIndex: 10000000000
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/FormFieldComponent.js